import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/i-copa-eu-amo-parintins-de-jiu-jitsu-2025/tabela-i-copa-eu-amo-parintins-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import esporteSemFundo from "../../assets/images/sponsors/esporte-sem-fundo.png"
import logoPrefeitura from "../../assets/images/sponsors/logo-prefeitura-parintins.png"





//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  { img: esporteSemFundo, url: "" },
  { img: logoPrefeitura, url: "" },
/*   { img: torneio, url: "http://www.torneiofacil.com" },
  */
 
];


const support = [
 
  { img: torneio, url: "http://www.torneiofacil.com" },
];


const dataEvento = "18 de outubro de 2025 "
const horaEvento = "8:00h da manhã"
const tituloEvento = "I Copa Eu Amo Parintins de Jiu Jitsu 2025"
const localEvento = "Arena Olímpica Rubem dos Santos"
const endereçoEvento = "R. Barreirinha - São Vicente de Paula, Parintins - AM, CEP 69153-005"
const dataDeEncerramentoIncricao = "15/SET/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "15/SET/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLoteUnico = ""
const dataDeEncerramentoInscricaoLote1 = "Completar 500 atletas inscritos"
const dataDeEncerramentoInscricaoLote2 = ""
const dataDeEncerramentoInscricaoLote3 = ""


const valorinscricaoCategoriaAbsoluto = "Gratuita"
const valorinscricaoCategoriaAbsolutoLote3 = ""
const valorinscricaoCategoriaLote1 = "Gratuita"
const valorinscricaoCategoriaLote2 = ""
const valorinscricaoCategoriaLote3 = ""

const valorinscricaoLoteUnicoComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote1ComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote2ComboGieAbsoluto = ""
const valorinscricaoLote3ComboGieAbsoluto = ""

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)"
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)"

const dataDeDivulgacaoChaves = "17/OUT/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99468-5161"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

 const slugGI = "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi";
const slugNOGI = "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-absoluto";
const rotaInscriçãoGi = "/enrollment/i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi";
const rotaChecagemGi = "/check/i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi/search";
const rotaChecagemAbsoluto = "/check/xxxiii-copa-orley-lobato-de-jiu-jitsu-parintins-am-absoluto/search";
const rotaChavesGI = "/tournament/keys/i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi" 
const rotaChavesAbsoluto = "/tournament/keys/xxxiii-copa-orley-lobato-de-jiu-jitsu-parintins-am-absoluto" 



const ICopaEuAmoParintisDeJiuJitsu2025: React.FC = () => {

  useEffect(() => {
    // Adiciona cache buster se não estiver presente
    if (!window.location.search.includes("cacheBuster")) {
      const cacheBuster = `cacheBuster=${new Date().getTime()}`;
      const newUrl = `${window.location.pathname}?${cacheBuster}`;
      window.location.replace(newUrl); // Redireciona para a nova URL
    }
  }, []);


  const { authenticated } = useAuthenticate();
  const navigate = useNavigate();
  const [tournamentGI, setTournamentGI] = useState<any>();
  const [tournamentNOGI, setTournamentNOGI] = useState<any>();

  useEffect(() => {
    api.get(`/tournaments/${slugGI}`).then(({ data }) => {
      setTournamentGI(data);
    });

    api.get(`/tournaments/${slugNOGI}`).then(({ data }) => {
      setTournamentNOGI(data);
    });
  }, []);

  const handleToSubscriptionPage = (url: string) => {
    if (tournamentGI!.canSubscribe || tournamentNOGI!.canSubscribe) {
      navigate(url);
      return;
    }

    const msg = "Período de inscrição encerrado.";

    Swal.fire({
      title: 'Atenção!',
      text: msg,
      icon: 'error',
    });

    toast.error(msg);
  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/i-copa-eu-amo-parintins-de-jiu-jitsu-2025/i-copa-eu-amo-parintins-de-jitsu-2025.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/i-copa-eu-amo-parintins-de-jiu-jitsu-2025/i-copa-eu-amo-parintins-de-jitsu-2025.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
               <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/VEJ5ndsfT2h2V67RA"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span> 
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento tradicional  que
                      fomenta e incentiva a prática do jiu jitsu no estado do Amazonas. As lutas
                      serão GI (com kimono), o evento disponibilizará
                      categorias para todas as idades e faixas, conforme a tabela de peso
                      deste edital. Os competidores terão a oportunidade de testar suas
                      habilidades em um ambiente controlado e com acompanhamento de
                      profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title= "PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇" >
                
                     <H3>Academias:</H3>
                    <P>1° lugar: R$2.000,00 + 🏆 Troféu </P>
                    <P>2° lugar: R$1.000,00 + 🏆 Troféu </P>
                    <P>3° lugar: R$500,00 + 🏆 Troféu </P>

                    <br />
                    <H3>Absoluto Masculino GI:</H3>
                    <H5>Adulto e Master - Azul/Roxa - (Juntos)</H5>
                    <P>1° lugar: R$400,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈</P>
                    <P>3° lugar: Medalha🥉</P>
                    <H5>Adulto e Master - Marrom/Preta - (Juntos)</H5>
                    <P>1° lugar: R$1.000,00 + Medalha 🥇</P>
                    <P>2° lugar: R$500,00 + Medalha🥈</P>
                    <P>3° lugar: R$200,00 + Medalha🥉</P>
                   
                    <br />

                    <H3>Absoluto Feminino GI:</H3>
               
                    <H5>Adulto e Master - Azul/Roxa - (Juntas)</H5>
                    <P>1° lugar: R$400,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈</P>
                    <P>3° lugar: Medalha🥉</P>
                    <H5>Adulto e Master - Marrom/Preta - (Juntas)</H5>
                    <P>1° lugar: R$1.000,00 + Medalha 🥇</P>
                    <P>2° lugar: R$500,00 + Medalha🥈</P>
                    <P>3° lugar: R$200,00 + Medalha🥉</P>
                    <br />
                    <H3>Demais Categorias GI</H3>
                    <P>1° lugar: medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <br />
                    <p>OBS: Estas premiações só irão valer para os Absolutos que tiverem 08 (OITO)
                    ou mais atletas inscritos.</p>
                    <p>Número menor que 8 atletas a premiação ficará a critério da organização do evento, podendo não ter premiação.</p>
                    <p>
                      Mais informações sobre as inscrições para o absoluto está disponível
                      na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                    </p>
                    <br />
                  </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min, ou até completar 500 atletas inscritos.
                  </P>
                  <br />
                  {/* <P>As inscrições que não forem pagas serão canceladas.</P> */}
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}
                  
                  <H3>Correção</H3>
{/*                   <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P> */}
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                {/*   <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P> */}
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    No ato da inscrição a correção já fica disponível.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P> 
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <P>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado.
                  </P>
                  <P>
                    Haverá um horário reservado de 10:30h às 11:00 para todos os atletas PCD .
                  </P>
               
                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão Gratuitas
                  </Span>
                {/*   <H3>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} </P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} </P>
                  <br />
                  <H3>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} </P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} </P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} </P>

                  <br />
                  <H3>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} </P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} </P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} </P> */}
                  <br />
                  <br />
               
                  
                </Collapse>
     {/*            <Collapse title="PAGAMENTO">
                    <H3>
                      A baixa do pagamento será efetuada de forma automática.
                    </H3>
                    <H3>
                      É necessário completar todas as etapas até finalizar a operação de pagamento.
                    </H3>
                   <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> 
                  <p />
                  <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> 
                </Collapse> */}

              {/*   <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                    <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3>
                  </Collapse> */}

                <Collapse title="REGRAS">
                
                   <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Na chave de três, após a primeira luta, o vencedor segue para a final e o perdedor segue 
                    para enfrentar o terceiro atleta da chave. O atleta que vencer a segunda luta, mesmo que 
                    seja o perdedor da primeira luta, segue então para a final com o vencedor da primeira luta.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  {/* <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                        ele lutará como Juvenil faixa Azul.
                  </Span>       

                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                 {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <Span>
                    Somente bandeira das equipes inscritas na competição vão poder ir paras as dependência da área de  premiação. 
                  </Span>
                  <Span>
                    Somente um professor ficará responsável por toda a equipe na competição.
                  </Span>
                  <Span>
                  Crianças até 10 anos poderam ser acompanhadas pelo professor autorizado, próximo a área de luta.
                  </Span>
                  <Span>
                    As equipes que efetuarem a inscrição do atleta e o mesmo não comparecer ao evento, perderá 5 pontos, salvo se apresentar justificativa 
                    de atestado médico, declaração de escola ou de trabalho.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>

                  
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P>
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P> 
                </Collapse>
                {/* <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}> */}
                <Collapse title={"CRONOGRAMA"}>
                  {/* (EM BREVE) */}

                  <Container>
                    <br />
                    <span>
                      CRONOGRAMA - I COPA EU AMO PARINTINS DE JIU JITSU 2025
                    </span>

                      <H5>8:00 - Abertura</H5>
                      <H5>8:15 - Faixa Preta/Marrom, Adulto e Masters, Masculino e Feminino (Categoria: Galo-Pesadissimo);</H5>
                      <H5>8:50 - Faixa Roxa, Adulto e Masters, Masculino e Feminino (Categoria: Galo-Pesadissimo);</H5>
                      <H5>10:00 - Faixa Azul, Adulto e Masters, Masculino e Feminino (Categoria: Galo-Pesadissimo);</H5>
                      <H5>11:00 - Faixa Branca, Adulto e Masters, Masculino e Feminino (Categoria: Galo-Pesadissimo);</H5>
                      <H5>12:30 - Intervalo Almoço</H5>
                      <H5>13:00 - Pré-Mirim, Mirim A e Mirim B, Branca e Graduado, Masculino e Feminino</H5>
                      <H5>13:45 - Infantil A, Branca e Graduado, Masculino e Feminino</H5>
                      <H5>14:10 - Infantil B, Branca e Graduado, Masculino e Feminino</H5>
                      <H5>15:00 - Infanto-Juvenil Branca e Graduado, Masculino e Feminino</H5>
                      <H5>15:45 - Juvenil Branca e Graduado, Masculino e Feminino</H5>
                      <H5>16:30 - Absolutos</H5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      {/* <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li> */}
                      {/* <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li> */}
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar em até 10h se for necessario para a finalização do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      {/* <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li> */}
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                    <P>Entrada liberada ao público.</P> 
                    <br />
 {/*                     <P>
                  Será cobrado 1kg de alimento não perecível na entrada para atletas e
                  público.
                </P> 
                     <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */} 
                 </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento entre em contato por telefone ou WhatsApp.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/559299468-5161/?t=Olá%20Michel%20Monte%20Verde!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*I%20COPA%20EU%20AMO%20PARINTINS%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*I%20COPA%20EU%20AMO%20PARINTINS%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  {/* <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage> */}

                  <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage(rotaInscriçãoGi)}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage to="" onClick={() => handleToSubscriptionPage("/login")}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI e ABSOLUTO
              </TournamentLink>

              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves GI e ABSOLUTO
              </TournamentLink>
        

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default ICopaEuAmoParintisDeJiuJitsu2025;
